export const getDispatchOrderDate = order => {
  for (const value of [order.created_at, order.createdAt, order.expected_dispatch_at]) {
    if (!value) continue;
    const date = new Date(value);
    if (Number.isFinite(date.getTime())) return date;
  }
  return null;
};

export const filterDispatchOrderDates = (orders, from = '', to = '') => orders
  .filter(order => {
    if (!from && !to) return true;
    const date = getDispatchOrderDate(order);
    if (!date) return false;
    const day = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return (!from || day >= from) && (!to || day <= to);
  })
  .sort((a, b) => (getDispatchOrderDate(b)?.getTime() || 0) - (getDispatchOrderDate(a)?.getTime() || 0)
    || Number(b.id || 0) - Number(a.id || 0));
